import React from "react";
import PropTypes from "prop-types";
import warning from "../../assets/img/warning.svg";
import OccupancyInfoBanner from "../occupancy-banner/OccupancyInfoBanner";

const TabularViewBanners = ({ propertyId, hasError, isEditable }) => {
  return (
    <>
      {hasError && isEditable && (
        <div className="manageari-error-container">
          <img src={warning} color="red" alt="" />{" "}
          <div>
            <strong>Minimum Allowable Daily Rate</strong>
            <br />
            <span>The daily rate cannot be zero or negative</span>
          </div>
        </div>
      )}
      <OccupancyInfoBanner
        storageKey={`showInfoTabularViewBanner_${propertyId}`}
        placeholderClassName="info-banner-tabular-view-placeholder"
        contentClassName="info-banner-content"
      />
    </>
  );
};

TabularViewBanners.propTypes = {
  propertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  hasError: PropTypes.bool,
  isEditable: PropTypes.bool,
};

export default TabularViewBanners;
